export default {"src":"/_next/static/media/safari-share.cbaba215.svg","height":169,"width":120,"blurWidth":0,"blurHeight":0};